<template>
  <div class="full-height tkRefundApply linear-main3">
    <ld-header
      :transparent="true"
      :white="true"
    >
      {{ $t('B020', '申请退票') }}
    </ld-header>
    <!--  -->
    <div class="tkRefundApplywrapper">
      <mescroll-vue
        :down="down"
      >
        <div class="content">
          <!--航段展示-->
          <div
            class="m-b-5"
            v-for="(info,index3) in tkOrderRangeBeanList"
            :key="index3"
          >
            <voyage
              :show-check="true"
              :show-cabin="true"
              :flights="[info]"
              @selected="voyageChange.call(this, index3)"
            >
              <template
                v-if="info.changeMap"
                #tag
              >
                <van-tag
                  size="medium"
                  color="#8b8ba6"
                >
                  <span>原行程</span>
                </van-tag>
                &nbsp;
              </template>
              <template
                #bottom
                v-if="info.changeMap"
              >
                <new-voyage
                  :flight="changeData(info.changeMap)"
                  :show-car="true"
                  :show-cabin="true"
                >
                  <template #tag>
                    <van-tag
                      class="bg-main white"
                      size="medium"
                    >
                      <span>新行程</span>
                    </van-tag>
                    &nbsp;
                  </template>
                  <template #bottom>
                    <van-row
                      class="noExitTip m-b-5 orange bg-lightColor"
                      gutter="8"
                    >
                      <van-col span="1">
                        <van-icon name="warning" />
                      </van-col>
                      <van-col span="21">
                        原行程发生过改签，按新行程进行退票！
                      </van-col>
                    </van-row>
                  </template>
                </new-voyage>
              </template>
            </voyage>
          </div>
          <!-- 乘机人 -->
          <van-cell
            class="m-b-5"
            v-for="(passItem,index1) in tkOrderPsgBeanList"
            :key="passItem.psgId"
          >
            <template slot="title">
              {{ passItem.psgName }}
              <van-tag
                type="warning"
                v-show="passItem.fsEmpId"
              >
                {{ $t('attach', '附') }}
              </van-tag>
            </template>
            <template
              slot="default"
            >
              <van-checkbox
                v-show="passItem.isShow"
                class="fr"
                v-model="passItem.checked"
                @change="choosePsg(index1)"
              />
            </template>
            <template
              slot="label"
            >
              <div
                style="width: 272px;"
              >
                {{ DocumentType[passItem.idType] }}：{{ passItem.idNo }}
              </div>
              <div>{{ $t('F008', '手机号') }}：{{ passItem.phoneNumber }}</div>
              <div v-if="passItem.oneTkno">
                {{ $t('F624', '一程票号') }}：{{ passItem.oneTkno }}
              </div>
              <div v-if="passItem.twoTkno">
                {{ $t('F625', '二程票号') }}：{{ passItem.twoTkno }}
              </div>
            </template>
          </van-cell>
          <RefundReason 
            v-if="tkOrderPsgBeanList.length >0 && tkOrderRangeBeanList.length > 0" 
            :fileList="fileList" 
            :orderId="orderId" 
            orderPamsCode="11601037"
            orderPamsCodeNo="11601039"
            :title="'自愿退票'" 
            :titleto="'非自愿退票'" 
            @fileList="fileList = $event" 
            @takein="cancelReasonnew" 
            :refundResaonNonew="refundResaonNonew" />
        </div>
      </mescroll-vue>
    </div>

    <!--提交申请-->
    <ld-tabbar class="bg-white">
      <van-row
        type="flex"
        align="center"
        gutter="8"
        class="full-width pad-lr-5"
      >
        <van-col span="12">
          退票费：
          <span class="font12 money-color">&yen;</span>
          <span class="font22 money-color">{{ total }}</span> 起
        </van-col>
        <van-col span="12">
          <ld-button
            main
            size="md"
            @click="toSubmitApply"
          >
            提交申请
          </ld-button>
        </van-col>
      </van-row>
    </ld-tabbar>
    <!--  -->
    <ld-check-list
      ref="cancelReason"
      type="5"
      :title="title"
      :params="parNo"
      @selected="cancelReason"
    />
    <!-- 退票再次提醒弹窗 -->
    <Refunddialog
      :popshow="popshow"
      :refundResaon="refundResaon"
      :isShowNoRefundReason="isShowNoRefundReason"
      :total="total"
      @continueSubmit="continueSubmit()"
      @cancel="popshow=false"
    />
  </div>
</template>

<script>
import ldButton from 'Common/ldButton'
// import { Cell , Field ,Checkbox ,Tag} from 'vant'
import {
  Cell,
  CellGroup,
  Field,
  Checkbox,
  Tag,
  Popup,
  Collapse,
  CollapseItem,
  Icon,
  NoticeBar,
  Uploader,
  Toast,
  Button,
  Form,
  Dialog
} from 'vant'
import voyage from 'Views/Tk/tkQuery/roundtrip/voyage/index.vue'
import newVoyage from 'Components/tk/voyage/voyage.vue'
import ldCheckList from 'Components/ldCheckList/TheReasonForTheChange/index'
import ldTabbar from 'Components/ldTabbar/ldTabbar'
import MescrollVue from 'mescroll.js/mescroll.vue'
import ldUploader from 'Components/ldUploader'
import axios from 'axios'
import {localget} from 'Utils/storage.js'
import {divisionCount} from 'Utils/tools'
import {API_DEFAULT_CONFIG} from 'Config'
import STATUSMAP from 'Utils/enum'
import Refunddialog from 'Views/Tk/components/refund_dialog.vue'
import {getParameter} from 'Utils/publicApi'
import  RefundReason  from 'Views/Tk/components/RefundReason.vue'

export default {
  name: 'TkRefundApply',
  data() {
    return {
      title: '选择自愿退票原因',
      parNo: '11601037',
      tkOrderPsgBeanList: [],
      tkOrderRangeBeanList: [],
      changeMap: {},
      ids: '',
      // 申请 退票入参
      refundType: 1,
      psgIdList: [],
      rangeIdList: [],
      // 自愿退票原因
      // refundReasonVip: '',
      //  非自愿退票原因
      refundResaon: '',
      isShowReason: false,
      refundResaonNo: '',
      //  订单类型  返回列表的参数
      findType: 1,
      // 是否显示非自愿退票原因
      isShowNoRefundReason: false,
      // 客人自愿退票（非自愿退票原因的第一条）
      middleReason: '',
      orderFrom: '',
      // showFei:false,
      total: 0,
      down: {use: false},

      // 上传附件
      fileList: [],
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      file: {},
      popshow:false,//是否显示弹窗
      refundResaonNonew:{
        refundResaonNo:false,
        message:"",
      },
      refundResaonhand:""
    }
  },
  components: {
    ldButton,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Field.name]: Field,
    [Checkbox.name]: Checkbox,
    [Tag.name]: Tag,
    [Icon.name]: Icon,
    [NoticeBar.name]: NoticeBar,
    [Uploader.name]: Uploader,
    [Toast.name]: Toast,
    [Button.name]: Button,
    [Form.name]: Form,
    [Dialog.name]: Dialog,
    voyage,
    ldCheckList,
    ldTabbar,
    MescrollVue,
    newVoyage,
    ldUploader,
    Refunddialog,
    RefundReason
  },
  // 计算属性   处理数据时，使用
  computed: {
    orderId() {
      return this.$route.query.orderId
    }
  },
  //页面创建时，去调用方法
  created() {
    this.getRefundOrder()
    this.getBclass()
  },
  mounted() {
    this.DocumentType = STATUSMAP
  },
  activated() {
    this.getRefundOrder()
    this.getBclass()
  },
  updated() {
    console.log('this', this)
  },
  methods: {
    //获取 可改签的航段 和 乘机人
    getRefundOrder() {
      this.$api['tkOrder/applyRefund']({
        orderId: this.orderId
      }).then((resp) => {
        let cache = resp.data || {}
        let obj1 = cache.tkOrderRangeBeanList
        cache.tkOrderPsgBeanList.sort((a, b) => {//根据行程排乘机人的循序
          return obj1.findIndex(o => o.rangeId == ((a.refundRangeIdList && a.refundRangeIdList.length) ? a.refundRangeIdList[0] : a.refundRangeIdList )) - obj1.findIndex(o => o.rangeId ==  ((b.refundRangeIdList && b.refundRangeIdList.length) ? b.refundRangeIdList[0] : b.refundRangeIdList ))
        })
        let checkArr = []
        cache.tkOrderPsgBeanList.forEach(item => {
          checkArr = checkArr.concat(item.refundRangeIdList)
        })
        cache.tkOrderRangeBeanList.forEach(v => {
          let judgeHas = checkArr.some(i => {
            return i == v.rangeId
          })
          if (judgeHas) {
            v.checkShow = true
          } else {
            v.checkShow = false
            v.isShow = true
            v.checked = false
          }
        })
        let tkOrderPsgBeanListnew=[] //处理往返显示一个人
        cache.tkOrderPsgBeanList.forEach((item)=>{
          let found = tkOrderPsgBeanListnew.findIndex((empId)=>{
            return (empId.empId == item.empId && empId.psgName==item.psgName && empId.phoneNumber==item.phoneNumber)  
          })
          if(found == -1) {
            if(item.refundRangeIdList){
              var refundRangeIdList=item.refundRangeIdList[0]
              item.psgIdrefundRangeId={}
              item.psgIdrefundRangeId[refundRangeIdList]=item.psgId
            }
            tkOrderPsgBeanListnew.push(item)
          }else{
            if(item.refundRangeIdList){
              var refundRangeIdList=item.refundRangeIdList[0]
              if(tkOrderPsgBeanListnew[found].refundRangeIdList){//第一个人是否有refundRangeIdList值，有则合并
                tkOrderPsgBeanListnew[found].refundRangeIdList = tkOrderPsgBeanListnew[found].refundRangeIdList.concat(item.refundRangeIdList)
              }else{
                tkOrderPsgBeanListnew[found].refundRangeIdList=item.refundRangeIdList
              }
              if( tkOrderPsgBeanListnew[found].psgIdrefundRangeId){//第一个人是否有psgIdrefundRangeId
                tkOrderPsgBeanListnew[found].psgIdrefundRangeId[refundRangeIdList]=item.psgId
              }else{
                tkOrderPsgBeanListnew[found].psgIdrefundRangeId={}
                tkOrderPsgBeanListnew[found].psgIdrefundRangeId[refundRangeIdList]=item.psgId
              }
             
            }
            if(tkOrderPsgBeanListnew[found].oneTkno){
              tkOrderPsgBeanListnew[found].twoTkno = item.twoTkno
            }else{
              tkOrderPsgBeanListnew[found].oneTkno = item.oneTkno
            }
          
          }
        })
        // this.tkOrderPsgBeanList = cache.tkOrderPsgBeanList || [] //乘积人 //原来逻辑
        // console.log("tkOrderPsgBeanListnew",tkOrderPsgBeanListnew)
        this.tkOrderPsgBeanList =tkOrderPsgBeanListnew || []
        this.tkOrderRangeBeanList = cache.tkOrderRangeBeanList || []
        this.changeMap = cache.changeMap || {}
      })
    },
    //获取第一条原因   客人自愿退票
    getBclass() {
      // this.$api['common/getBClass']({parNo: 130}).then(res => {
      this.$api['common/getBClass']({parNo: 11601039}).then(res => {
        var reasonList = res.data.list
        reasonList.forEach((item) => {
          if (item.id == 13001) {
            this.middleReason = item.cName
          }
        })
      })
    },
    //选择行程选择可退票航段    复选模式
    voyageChange(index) {
      this.rangeIdList = []
      this.tkOrderRangeBeanList.forEach(item => { //机票的
        if (item.checked) {
          this.rangeIdList.push(item.rangeId)
        }
      })
      this.chooseOneRangeAndShowPass(this.rangeIdList)
    },
    //当某一航段 被选中时，自动匹配可退票乘机人 ，供客户勾选
    chooseOneRangeAndShowPass(rangeId, boolean) {
      // tkOrderPsgBeanList 为所有的乘客
      this.tkOrderPsgBeanList.forEach(item => {
        // 每个人身上的可退航段id的数组 refundRangeIdList
        var rangeArr = item.refundRangeIdList || []
        let judgeArr = [...new Set(rangeArr)].filter(item => new Set(rangeId).has(item))
        if (judgeArr.length) {
          item.isShow = true
        } else {
          item.isShow = false
        }
      })
      //当勾选航段时，找到乘机人对应的id 
      this.psgIdList=[]
      this.rangeIdList.forEach((item)=>{
        this.tkOrderPsgBeanList.forEach((item2)=>{
          if(item2.checked){
            this.psgIdList.push(item2.psgIdrefundRangeId[item])
          }
        })
      })
      let arr = this.tkOrderPsgBeanList
      this.tkOrderPsgBeanList = []
      this.tkOrderPsgBeanList = arr
    },
    //选择非自愿退票原因
    chooseReason(parNo, title) {
      this.parNo = parNo
      this.title = title
      if (parNo === '11601039') {
        this.refundType = 2
      }
      this.$refs.cancelReason.toggle({params: parNo, title: title})
    },
    //取消原因
    cancelReason(info) {
      // if(this.parNo==11601037){
      // 	this.refundReasonVip=info.cName
      // }else{
      // this.refundResaon = info.cName
      // this.refundResaon = info.reasonDesc
      // }
      info.cName ? this.refundResaon=info.cName : this.refundResaon=info
    },
    cancelReasonnew(info) {
      if (info == '04271202') {
        this.refundResaonhand = info
      } else {
        this.refundResaon = info
        this.refundResaonhand = ''
      }
    },
    // 选择可退票乘机人
    choosePsg(index) {
      let val = this.tkOrderPsgBeanList[index]
      if (val.checked) {
        if (this.psgIdList.indexOf(val.psgId) == -1) {
          if(this.rangeIdList.length > 0){
            this.rangeIdList.forEach((item)=>{
              this.psgIdList.push(val.psgIdrefundRangeId[item]);
            })
          }
        }
      } else {
        for(let key in val.psgIdrefundRangeId){
          let index=this.psgIdList.indexOf(val.psgIdrefundRangeId[key])
          if(index !=-1){
            this.psgIdList.splice(index,1)
          }
        }
      }
      var self = this

      if (this.psgIdList && this.psgIdList.length) {
        this.tkOrderRangeBeanList.forEach(item => {
          if (item.checked) {
            self.psgIdList.forEach(el => {
              if (self.changeMap[el + item.rangeId]) {
                item.changeMap = self.changeMap[el + item.rangeId]
              }
            })
          } else {
            item.changeMap = ''
          }
        })
        let arr = this.tkOrderPsgBeanList
        this.tkOrderPsgBeanList = []
        this.tkOrderPsgBeanList = arr
      }
    },

    // 提交申请
    toSubmitApply(obj) {
      let rangeIdListString = this.rangeIdList.join(',')
      let psgIdListString = this.tkOrderPsgBeanList.filter(item => {
        return item.checked
      })
      let ing=[]
      psgIdListString.forEach(item =>{
        this.rangeIdList.forEach((item2)=>{
          ing.push(item.psgIdrefundRangeId[item2])
        })
      })
      psgIdListString = ing.join(',')

      let fileArr = []
      this.fileList.forEach(o => {
        fileArr.push(o.url)
      })
      if(this.refundResaonhand=='04271202' &&  this.refundResaonNonew.message){
        this.refundResaon=this.refundResaonNonew.message
      }

      if (rangeIdListString === '') {
        this.$toast('请选择退票航段！')
        return false
      } else if (psgIdListString === '') {
        this.$toast('请选择乘机人！')
        return false
      }  else if(this.refundResaonhand=='04271202' && this.refundResaonNonew.message==''){
        this.$toast('请输入退票原因')
        return false
      }  else if (this.refundResaon == '' && this.selectReason) {
        this.$toast('请选择退票原因！')
        return false
      }  else if(this.refundResaon === '') {
        this.$toast('请选择退票原因！')
        return false
      }	else if(this.changeApplyRemark=='' && this.entry){
        return this.$toast('请手动填写退票原因！')
      }
      else {
        // if(this.refundResaon != '') {
        // 	this.refundType = 2
        // } else {
        // 	this.refundType = 1
        // 	this.refundResaon = this.middleReason
        // }
        let queryString = {
          'orderId': this.orderId,
          'psgIdList': psgIdListString,
          'rangeIdList': rangeIdListString,
          'refundProveUrl': fileArr.join(','),
          'refundReasonVip': '-',
          'refundResaon': this.refundResaon,
          'refundType': this.refundType,
          'orderFrom': '10506',  // app
        }
        this.popshow=true
        if(obj=='yes'){
          this.$api['tkOrder/refundAdd'](queryString).then((resp) => {
            let cache = resp.data || {}
            let arr = cache.refundIdList || []
            if (arr.length > 1) {
              this.$dialog({
                title: '提交成功',
                confirmButtonText: '前往',
                message: '系统生成' + (this.psgIdList.length) + '个订单前往订单列表查看',
              }).then(() => {
                this.$router.push({
                  path: '/allOrder?findType=4',
                  query: {findType: 4}
                })
              })
            } else if (arr.length == 1) {
              this.$router.push({path: '/tk/tkRefundCmp', query: {orderId: arr[0]}})
            } else {
              this.$toast('申请失败')
            }
          })
        }
      }
    },
    //继续提交
    continueSubmit() {
      let obj = 'yes'
      this.popshow = false
      this.toSubmitApply(obj)
    },

    changeFei() {
      this.isShowNoRefundReason = true
      // this.showFei=true
      this.refundResaon = ''
    },
    //取消非自愿退票
    cancleNoExit() {
      this.isShowNoRefundReason = false
      // this.showFei=false
      this.refundResaon = ''
    },
    matchNowFlightRule() {
      var psgBeanList = []
      if (this.tkOrderPsgBeanList.length) {
        this.tkOrderPsgBeanList.forEach(item => {
          if (item.checked) {
            this.rangeIdList.forEach((item2)=>{
              psgBeanList.push({
                psgId: item.psgIdrefundRangeId[item2],
                rangeIds: this.rangeIdList.join(',')
              })
            })
          }
        })
      }
      if (psgBeanList.length) {
        this.$api['tkOrder/matchNowFlightRule']({
          'orderId': this.orderId,
          'psgBeanList': psgBeanList,
          // [
          // 	{
          // 		'psgId': '',
          // 		'rangeBeanList': [
          // 			{
          // 				'rangeId': ''
          // 			}
          // 		]
          // 	}
          // ],
          'operFlag': 1//1 退票 2改签
        }).then(res => {
          var cache = res.data || []
          this.total = 0
          cache.forEach(item => {
            if (item.ruleBeanList) {
              item.ruleBeanList.forEach(el => {
                this.total += Number(el.result)
              })
            }
          })
        })
      }
    },
    changeData(item) {
      // 	newChange:false,
      // 	airlineName:item.airlineName,
      // 	departDate:item.oDepartDate,
      // 	departWeek:item.oDepartWeek,
      // 	departTime:item.oDepartTime,
      // 	arriveDate:item.oArriveDate,
      // 	arriveWeek:item.oArriveWeek,
      // 	arriveTime:item.oArriveTime,
      // 	departAirportName:item.oDepartAirportName,
      // 	arriveAirportName:item.oArriveAirportName,
      // 	departTerminal:item.oDepartTerminal,
      // 	arriveTerminal:item.oArriveTerminal,
      // 	departCityName:item.oDepartCityName,
      // 	arriveCityName:item.oArriveCityName,
      // 	flightNo:item.oFlightNo,
      // 	model:item.oModel,
      // 	cabinName:item.oCabinName,
      // 	cabin:item.oCabin,
      // 	stopFlag:item.oStopFlag,
      // 	stopCity:item.oStopCity,
      // 	stopCityName:item.oStopCityName,
      // 	stopAirport:item.oStopAirport,
      // 	stopAirportName:item.oStopAirportName,
      // 	stopArriveTime:item.oStopArriveTime,
      // 	stopDepartTime:item.oStopDepartTime,
      // },
      return {
        newChange: true,
        airlineName: item.newAirlineName,
        arriveWeek: item.narriveWeek,
        flightNo: item.newFlightNo,
        model: item.nModel,
        cabinName: item.nCabinName,
        cabin: item.nCabin,
        departAirportName: item.newDepartAirportName,
        arriveAirportName: item.newArriveAirportName,
        departCityName: item.newDepartCityName,
        arriveCityName: item.newArriveCityName,
        departDate: item.newDepartDate,
        departTime: item.newDepartTime,
        departWeek: item.newWeek,
        arriveDate: item.newArriveDate,
        arriveTime: item.newArriveTime,
        departTerminal: item.nDepartTerminal,
        arriveTerminal: item.nArriveTerminal,
        flyTime: item.nFlyTime,
        refundRule: item.nRefundRule,
        changeRule: item.nChangeRule,
        upgradeRule: item.nUpgradeRule,
        stopFlag: item.nStopFlag,
        stopCity: item.nStopCity,
        stopCityName: item.nStopCityName,
        stopAirport: item.nStopAirport,
        stopAirportName: item.nStopAirportName,
        stopArriveTime: item.nStopArriveTime,
        stopDepartTime: item.nStopDepartTime,
        shareFlightNo: item.nShareFlightNo,
      }
    },

    // 返回布尔值
    beforeRead(file) {
      if (file instanceof Array) {
        // 判断是否是数组
        file.forEach((v) => {
          this.checkFile(v)
        })
      } else {
        this.checkFile(file)
      }
      return true
    },
    // 图片类型检查
    checkFile(file) {
      const format = ['jpg', 'png', 'jpeg']
      const index = file.name.lastIndexOf('.')
      const finalName = file.name.substr(index + 1)
      if (!format.includes(finalName.toLowerCase())) {
        Toast('请上传' + format.join(',') + '格式图片')
        return false
      }
    },
    afterRead(file) {
      if (file instanceof Array) {
        file.map((v) => {
          v.status = 'uploading'
          v.message = '上传中...'
          this.uploadImg(v)
        })
      } else {
        file.status = 'uploading'
        file.message = '上传中...'
        this.uploadImg(file)
      }
    },
    // 上传
    uploadImg(file) {
      const formData = new FormData()
      formData.append('file', file.file)
      formData.append('token', localget('access_token'))
      formData.append('sysCode', 7000)
      formData.append('timeout', -1)
      let uploadUrl = API_DEFAULT_CONFIG.URL.uploadFileUrl
      // let uploadUrl = 'http://oss.tmc.tianxiafen.com/ser/parentSystemDfs/1.0.0/file/web/upload';
      axios.post(uploadUrl, formData, {
        headers: this.headers,
      }).then((res) => {
        if (res.data && res.data.data) {
          file.status = 'success'
          file.message = ''
          file.url = res.data.data
        }
      }).catch((err) => {
        this.$notify({
          type: 'warning',
          message: '上传失败',
        })
      })
    },
    //删除
    delUploadImg(item) {
      this.fileList = this.fileList.filter((v) => v.url != item.url)
    }
  },
  watch: {
    'rangeIdList.length'(val) {
      if (val) {
        this.matchNowFlightRule()
      }
    },
    'psgIdList.length'(val) {
      if (val) {
        this.matchNowFlightRule()
      }
    }
  }
}

</script>

<style lang="less" scoped>
.content {
  padding: 0 8px;
}

.m-b-5 {
  margin-bottom: 5px;
}

.pad-lr-5 {
  padding-left: 5px;
  padding-right: 5px;
}

.noExitTip {
  padding: 4px 8px;
  font-size: 10px;
}

.tkRefundApplywrapper {
  height: calc(100vh - 96px);
  overflow: hidden;
}

</style>
